import styled from "styled-components";
import { EmptyIcon } from "../Icon/EmptyIcon";

export const StyledEmptyCard = styled('div')`
    ${({theme}: any)=> `
        margin-top: ${theme.uptimeSpace[5]}px;
        background-color: ${theme.uptimeColors.mainTheme.background};
        border-radius: 10px;
        padding: ${theme.uptimeSpace[20]}px ${theme.uptimeSpace[5]}px;
    `}
`;

export const StyledEmptyIcon = styled(EmptyIcon)`
    display: block;
    margin: 0 auto;
    width: 86px;
`;

export const StyledEmptyText = styled('p')`
  ${({theme}: any) => `
    margin: ${theme.uptimeSpace[10]}px 0 0;
    color: ${theme.uptimeColors.grayScales.darkerGray};
    font-size: ${theme.uptimeFontSizes.desktop.fz1}px;
    line-height: ${theme.uptimeLineHeights.desktop.lh2}px;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
  `}  
`;